import { connect } from "react-redux";
import OrderDetail from "../components/OrderDetail/OrderDetail";
import * as actions from "../redux/actions/OrderDetail";
import { getUser } from "../redux/actions/AccountSetting";

import { push } from "react-router-redux";

const mapStateToProps = (state) => ({
  user: state.accountSetting.user,
  isOrderLoading: state.orderDetail.isOrderLoading,
  order: state.orderDetail.order,
  isLoadingOrderAddresses: state.orderDetail.isLoadingOrderAddresses,
  orderAddresses: state.orderDetail.orderAddresses
    .toIndexedSeq()
    .toArray(),
  pageInfo: state.orderDetail.pageInfo,
  message: state.orderDetail.message,
  shortMessage: state.orderDetail.shortMessage,
  errorMessage: state.orderDetail.errorMessage,
  pathname: state.router.location.pathname,
  search: state.router.location.search,
});

const mapDispatchToProps = (dispatch) => ({
  getOrderById(id, data) {
    dispatch(actions.getOrderById(id, data));
  },

  getOrderAddresses(id, data, overwrite) {
    dispatch(actions.getOrderAddresses(id, data, overwrite));
  },

  goTo(url, state) {
    dispatch(push(url, state));
  },

  getUserInfo() {
    dispatch(getUser());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);



// WEBPACK FOOTER //
// ./src/containers/OrderDetail.js